/**
 * Studio Font Options
 *
 * Curated list of fonts for the appearance settings.
 * "default" uses the existing NEXT Pan font loaded via next/font/local.
 * All others are loaded via Google Fonts <link> tag at runtime.
 */

export interface FontOption {
  key: string;
  label: string;
  /** Google Fonts family name, or null for the default local font */
  googleFamily: string | null;
  /** CSS font-family value including fallbacks */
  cssFamily: string;
  /** Short description shown in the font picker */
  description: string;
}

export const FONT_OPTIONS: FontOption[] = [
  {
    key: "default",
    label: "Default (NEXT Pan)",
    googleFamily: null,
    cssFamily: "inherit",
    description: "The studio default font",
  },
  {
    key: "Inter",
    label: "Inter",
    googleFamily: "Inter",
    cssFamily: "'Inter', sans-serif",
    description: "Clean sans-serif, popular in SaaS",
  },
  {
    key: "DM Sans",
    label: "DM Sans",
    googleFamily: "DM+Sans",
    cssFamily: "'DM Sans', sans-serif",
    description: "Geometric, modern",
  },
  {
    key: "Space Grotesk",
    label: "Space Grotesk",
    googleFamily: "Space+Grotesk",
    cssFamily: "'Space Grotesk', sans-serif",
    description: "Techy, distinctive",
  },
  {
    key: "Sora",
    label: "Sora",
    googleFamily: "Sora",
    cssFamily: "'Sora', sans-serif",
    description: "Rounded, friendly",
  },
  {
    key: "Outfit",
    label: "Outfit",
    googleFamily: "Outfit",
    cssFamily: "'Outfit', sans-serif",
    description: "Contemporary, versatile",
  },
  {
    key: "JetBrains Mono",
    label: "JetBrains Mono",
    googleFamily: "JetBrains+Mono",
    cssFamily: "'JetBrains Mono', monospace",
    description: "Monospace, hacker aesthetic",
  },
];

export const FONT_OPTION_MAP = Object.fromEntries(
  FONT_OPTIONS.map((font) => [font.key, font]),
) as Record<string, FontOption>;

/**
 * Returns the Google Fonts stylesheet URL for a given font key.
 * Returns null for the default font (loaded locally).
 */
export function getGoogleFontUrl(fontKey: string): string | null {
  const font = FONT_OPTION_MAP[fontKey];
  if (!font?.googleFamily) return null;
  return `https://fonts.googleapis.com/css2?family=${font.googleFamily}:wght@400;500;600;700&display=swap`;
}
